export enum DepositTransferablePropsNames {
  initialMethodRef = 'initialMethodRef'
}

export type DepositTransferableProps = {
  [entry in DepositTransferablePropsNames]?: string | number | null;
};
